import { SporsmalType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { ForsikringsnummerSporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentForsikringsnummerSporsmal {
    type: SporsmalType.Forsikringsnummer;
    sporsmal: ForsikringsnummerSporsmal;
    forsikringsnummer?: string;
}

export interface BesvartForsikringsnummerSporsmal {
    type: SporsmalType.Forsikringsnummer;
    sporsmal: ForsikringsnummerSporsmal;
    forsikringsnummer: string;
}

export const isForsikringsnummerSporsmal = (
    currentSporsmal: CurrentSporsmal,
): currentSporsmal is CurrentForsikringsnummerSporsmal => currentSporsmal.type === SporsmalType.Forsikringsnummer;
